module.exports = __webpack_public_path__ + "img/design@3x.36763be2.png";